import { useMutation, useQueryClient } from '@tanstack/react-query';
import { RefreshCw } from 'lucide-react';
import type { AccountSyncResult } from '@ema-atr/shared';
import { api } from '../api';

export function AccountSyncButton({ accountId, disabled = false }: { accountId?: string; disabled?: boolean }) {
  const queryClient = useQueryClient();
  const sync = useMutation({
    mutationFn: () => api<AccountSyncResult[]>(accountId ? `/api/accounts/${encodeURIComponent(accountId)}/sync` : '/api/accounts/sync', { method: 'POST' }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ predicate: (query) => ['accounts', 'account', 'history', 'performance'].includes(String(query.queryKey[0])) });
    }
  });
  const failures = sync.data?.filter((item) => item.error || item.historyError) ?? [];
  return <div className="sync-control">
    <button className="secondary-button" disabled={disabled || sync.isPending} onClick={() => sync.mutate()}>
      <RefreshCw size={18} className={sync.isPending ? 'spin' : ''} />{sync.isPending ? '同步中…' : '立即同步'}
    </button>
    <span className={`sync-feedback ${sync.error || failures.length ? 'negative' : 'muted-copy'}`} role="status">
      {sync.error ? `同步失败：${sync.error.message}` : failures.length ? failures.map((item) => `${item.accountId}：${item.error ?? `历史同步失败：${item.historyError}`}`).join('；') : sync.isSuccess ? '同步完成' : ''}
    </span>
  </div>;
}
